import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/styles';
import axios from '../../config/axios';
import clsx from 'clsx';
import DetailShowroomCard from './components/DetailShowroomCard/DetailShowroomCard';
import { Link } from 'react-router-dom';
import TimetableTableList from './components/TimetableTableList/TimetableTableList';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import {
    Grid,
    Card,
    CardHeader,
    Box,
    Divider,
    Table,
    Tabs,
    Typography,
    Tab,
    TableBody,
    TableRow,
    TableCell,
    CardContent,
    Button
} from '@material-ui/core';
import PropTypes from 'prop-types'

import BookingCalendar from '../../components/BookingCalendar/BookingCalendar';
import DetailData from '../../pages/DetailShowroom/components/DetailData/DetailData';
import { get_all_showroom_timetable, get_showroom_details, get_agencies, get_showroom_agencies } from '../../api/API';
import Moment from 'react-moment';
import moment from 'moment/moment.js'
import SwapVertIcon from '@material-ui/icons/SwapVert';
import BlockCard from '../../components/BlockCard/BlockCard'
import AddShowflat from './components/AddShowflat/AddShowflat';
import AddAgency from './components/AddAgency/AddAgency';
import AddOperator from './components/AddOperator/AddOperator';
import CopyDate from './components/CopyDate/CopyDate';
import { TvTwoTone } from '@material-ui/icons';
import { delete_agencies_property, delete_showroom_unit, delete_operator_property, get_all_operators } from '../../api/API';
import "./DetailShowroom.css";
import ReorderUnits from './components/ReorderUnits/ReorderUnits';
import SpecialDates from './components/SpecialDates/SpecialDates';

var Reorder = require('react-reorder');


const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },

    results: {
        marginTop: theme.spacing(3)
    },

    pdTop: {
        margin: '30px',
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
}));

function ListItem(item) {
    return (
        <div>
            {item.name}
        </div>
    )
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};


export default class DetailShowroom extends React.Component {

    agency_modal = React.createRef();
    constructor(props) {
        super(props);

        this.state = {
            property: null,
            role: window.localStorage.getItem("role"),
            timetable: {
                standard: [],
                special: []
            },
            property_id: props.property_id,
            open: false,
            setOpenAdd: 'none',
            addSpecialDay: false,
            agencies: [],
            all_agencies: [],
            other_agencies: [],
            other_operators: [],
            value: {
                currentTab: 0,
                showroomTab: 0
            },
            unadded_agencies: []
        }
        this.copy_date_form = null;
    }


    a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    handleAddAgencyOpen = () => {
        console.log(this);
        this.setState({
            ...this.state,
            open: true,
            setOpenAdd: 'addAgency'
        });
    }

    handleAddOperatorOpen = () => {
        console.log(this);
        this.setState({
            ...this.state,
            open: true,
            setOpenAdd: 'addOperator'
        });
    }

    handleAddClose = () => {
        this.setState({
            ...this.state,
            open: false,
            setOpenAdd: 'none'
        });
        this.get_data();
    }

    delete_agency = async (agency_id) => {

        if (!window.confirm("Are you sure ?")) {
            return;
        }
        let data = await delete_agencies_property(agency_id, this.state.property_id);
        if (data) {
            this.refresh();
        }
    }

    delete_unit = async (showroom_unit) => {
        if (!window.confirm("Are you sure ?")) {
            return;
        }
        let data = await delete_showroom_unit(showroom_unit);
        if (data) {
            this.refresh();
        }
    }
    delete_operator = async (operator_id) => {
        if (!window.confirm("Are you sure ?")) {
            return;
        }
        let data = await delete_operator_property(operator_id, this.state.property_id);
        if (data) {
            this.refresh();
        }
    }
    refresh() {
        this.get_data();
    }


    async get_data() {
        let property_data = await get_showroom_details(this.props.property_id);
        if (property_data) {
            this.setState({
                ...this.state,
                property: property_data
            });
        }

        let data = await get_all_showroom_timetable(this.props.property_id);

        if (data) {
            console.log(data);
            this.setState({
                ...this.state,
                timetable: data
            }, async () => {
                let data = await get_agencies();
                if (data) {
                    this.setState({
                        ...this.state,
                        all_agencies: data
                    }, async () => {
                        let property_agencies = await get_showroom_agencies(this.props.property_id);
                        if (property_agencies) {
                            this.setState({
                                ...this.state,
                                agencies: property_agencies
                            }, () => {
                                let unadded_agencies = [];
                                for (let i = 0; i < this.state.all_agencies.length; i++) {
                                    var exist = false;
                                    for (let j = 0; j < property_agencies.length; j++) {
                                        if (property_agencies[j].agency_id == this.state.all_agencies[i].agency_id) {
                                            exist = true;
                                            break;
                                        }
                                    }

                                    if (!exist) {
                                        unadded_agencies.push(this.state.all_agencies[i]);
                                    }
                                }

                                this.setState({
                                    ...this.state,
                                    unadded_agencies: unadded_agencies
                                }, async () => {
                                    let operator_data = await get_all_operators();
                                    let unadded_operators = [];
                                    if (operator_data) {
                                        for (let i = 0; i < operator_data.length; i++) {
                                            var exist = false;
                                            for (let j = 0; j < this.state.property.operators.length; j++) {
                                                if (operator_data[i].showroom_operator_id == this.state.property.operators[j].showroom_operator_id) {
                                                    exist = true;
                                                    break;
                                                }
                                            }
                                            if (!exist) {
                                                unadded_operators.push(operator_data[i]);
                                            }
                                        }
                                    }
                                    this.setState({
                                        ...this.state,
                                        unadded_operators: unadded_operators
                                    }, () => {
                                        console.log(this.state);
                                    });
                                });

                            });
                        }


                    });
                }
            });
        }




    }

    openAddSpecialDay() {
        // this.copy_date_form.clearForm();
        this.setState({
            ...this.state,
            addSpecialDay: true
        });


    }

    closeAddSpecialDay() {
        this.setState({
            ...this.state,
            addSpecialDay: false
        });
        this.get_data();
    }

    async componentWillMount() {


        this.get_data();

    }
    handleChange = (event, newValue) => {
        this.setState({
            ...this.state,
            value: {
                currentTab: newValue
            }

        });
    };
    handleShowroomTabChange = (event, newValue) => {
        this.setState({
            ...this.state,
            value: {
                ...this.state.value,
                showroomTab: newValue
            }

        });
    };



    render() {

        return (

            <div className={this.props.classes.root} style={{
                height: 'unset'
            }}>


                <Grid >
                    {this.state.appointments ?

                        <DetailShowroomCard classes={this.props.classes} appointments={this.state.appointments} /> : ''
                    }
                </Grid>

                {(this.state.property && this.state.role != "showroom_operator") ?
                    <Grid
                        className={this.props.classes.container}
                        container
                        spacing={3}
                    >

                        <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                        >
                            <Card>
                                <CardHeader
                                    title="Showroom Detail"
                                    action={(
                                        <React.Fragment>
                                            <Link to={"/showroom/editshowroom/" + this.state.property_id}>
                                                <Button variant="contained">
                                                    <EditIcon />
                                                </Button>
                                            </Link>

                                        </React.Fragment>
                                    )}
                                />
                                <Divider />
                                <CardContent >
                                    <Tabs value={this.state.value.showroomTab} onChange={this.handleShowroomTabChange}>
                                        <Tab label="info"  {...a11yProps(0)}></Tab>
                                        {this.state.property.require_showroom_unit == "1" && (
                                            <Tab label="units"  {...a11yProps(1)}></Tab>
                                        )}
                                        <Tab label="access"  {...a11yProps(this.state.property.require_showroom_unit == '1' ? 1 : 2)}></Tab>
                                        <Tab label="Group Sizes"  {...a11yProps(this.state.property.require_showroom_unit == '1' ? 2 : 3)}></Tab>
                                    </Tabs>
                                    <TabPanel value={this.state.value.showroomTab} index={0}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>Name</TableCell>
                                                    <TableCell>
                                                        <span style={{
                                                            width: 14,
                                                            height: 14,
                                                            borderRadius: 7,
                                                            marginRight: 10,
                                                            position: "relative",
                                                            top: 2,
                                                            display: 'inline-block',
                                                            backgroundColor: this.state.property.color
                                                        }}></span>
                                                        {this.state.property.name} ({this.state.property.short_name})
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Description</TableCell>
                                                    <TableCell>
                                                        {this.state.property.description}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Max Pax Per Timeslot</TableCell>
                                                    <TableCell>
                                                        {this.state.property.max_appointment}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Max Group Size Per Appointment</TableCell>
                                                    <TableCell>
                                                        {this.state.property.special_dates.length > 0 ? (
                                                            <>
                                                                {this.state.property.special_dates[0].max_pax}
                                                                <br />
                                                                <small
                                                                style={{
                                                                    color: "#878787",
                                                                    textDecoration: "underline",
                                                                    cursor: "pointer"
                                                                }}
                                                                onClick={(e)=>{

                                                                    var tab = this.state.property.require_showroom_unit == '1' ? 3:2;
                                                                    this.handleShowroomTabChange(e, tab);
                                                                }}
                                                                >{" (From " + this.state.property.special_dates[0].start_date + " to " + this.state.property.special_dates[0].end_date + ")"}</small>
                                                            </>
                                                        ) : (
                                                            this.state.property.max_pax
                                                        )}

                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Requires showroom unit?</TableCell>
                                                    <TableCell>{this.state.property.require_showroom_unit == '1' ? 'Yes' : 'No'}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Requires guest nationality?</TableCell>
                                                    <TableCell>{this.state.property.require_nationality == '1' ? 'Yes' : 'No'}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TabPanel>
                                    {this.state.property.require_showroom_unit == '1' ? (

                                        <TabPanel value={this.state.value.showroomTab} index={1}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: "flex-end",
                                                marginBottom: 20
                                            }}>
                                                <Button
                                                    onClick={() => {
                                                        this.setState({
                                                            ...this.state,
                                                            open: true,
                                                            setOpenAdd: 'reorder_units'
                                                        });
                                                    }}
                                                    variant="contained" style={{
                                                        marginRight: 20
                                                    }} >
                                                    <SwapVertIcon className={this.props.classes.leftIcon} />
                                                </Button>

                                                <Button
                                                    onClick={() => {
                                                        this.setState({
                                                            ...this.state,
                                                            open: true,
                                                            setOpenAdd: 'addShowroomUnit'
                                                        });
                                                    }}
                                                    variant="contained" style={{

                                                    }} >
                                                    <AddIcon />
                                                </Button>
                                            </div>
                                            <div className="units_container">
                                                <Grid container>
                                                    {this.state.property.units.map(unit => (
                                                        <Grid item lg={3} md={4} xs={6} className="units_wrapper">
                                                            {unit.name}
                                                            <Button
                                                                onClick={((e) => {
                                                                    this.delete_unit(unit.showroom_unit_id)
                                                                }).bind(this)}
                                                                className="action_button"
                                                            >
                                                                <DeleteIcon
                                                                    className={this.props.classes.leftIcon}></DeleteIcon>
                                                            </Button>
                                                        </Grid>
                                                    ))}
                                                </Grid>

                                            </div>


                                        </TabPanel>

                                    ) : (<></>)}
                                    <TabPanel value={this.state.value.showroomTab} index={this.state.property.require_showroom_unit == '1' ? 2 : 1}>
                                        <div class="users_container">
                                            <div class="users_col">
                                                <h2>Agencies
                                                    <Button style={{
                                                        float: 'right',
                                                    }}
                                                        onClick={() => {
                                                            this.setState({
                                                                ...this.state,
                                                                open: true,
                                                                setOpenAdd: "addAgency"
                                                            });
                                                        }}
                                                        variant="contained"><AddIcon></AddIcon>
                                                    </Button>


                                                </h2>
                                                <br></br>
                                                <hr></hr>
                                                {this.state.agencies.map(row => (
                                                    <div class="users_wrapper">
                                                        {row.name}
                                                        <Button
                                                            className="action_button"
                                                            onClick={((e) => {
                                                                this.delete_agency(row.agency_id);
                                                            }).bind(this)}
                                                        >
                                                            <DeleteIcon className={this.props.classes.leftIcon} />
                                                        </Button>
                                                    </div>
                                                ))}
                                            </div>
                                            <div class="users_col">
                                                <h2>Operators

                                                    <Button style={{
                                                        float: 'right'
                                                    }}
                                                        onClick={() => {
                                                            this.setState({
                                                                ...this.state,
                                                                open: true,
                                                                setOpenAdd: "addOperator"
                                                            });
                                                        }}
                                                        variant="contained"><AddIcon></AddIcon>
                                                    </Button>
                                                </h2>
                                                <br></br>
                                                <hr></hr>
                                                {this.state.property.operators.map(row => (
                                                    <div class="users_wrapper">
                                                        {row.name}

                                                        <Button
                                                            className="action_button"
                                                            onClick={((e) => {
                                                                this.delete_operator(row.showroom_operator_id);
                                                            }).bind(this)}
                                                        >
                                                            <DeleteIcon className={this.props.classes.leftIcon} />

                                                        </Button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </TabPanel>
                                    <TabPanel value={this.state.value.showroomTab} index={this.state.property.require_showroom_unit == '1' ? 3 : 2}>
                                        <SpecialDates
                                            property_id={this.props.property_id}
                                        ></SpecialDates>
                                    </TabPanel>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* <Grid
                            item
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                        >
                            <Card>
                                <CardHeader
                                    title="Users"

                                />

                                <Divider />
                                <CardContent >
                                    <div class="users_container">
                                        <div class="users_col">
                                            <h3>Users</h3>
                                            {this.state.agencies.map(row => (
                                                <div class="users_wrapper">
                                                    {row.name}
                                                    <Button
                                                        className="action_button"
                                                        onClick={((e) => {
                                                            this.delete_agency(row.agency_id);
                                                        }).bind(this)}
                                                    >
                                                        <DeleteIcon className={this.props.classes.leftIcon} />
                                                    </Button>
                                                </div>
                                            ))}
                                        </div>
                                        <div class="users_col">
                                            <h3>Operators</h3>
                                            {this.state.property.operators.map(row => (
                                                <div class="users_wrapper">
                                                    {row.name}

                                                    <Button
                                                        className="action_button"
                                                        onClick={((e) => {
                                                            this.delete_operator(row.showroom_operator_id);
                                                        }).bind(this)}
                                                    >
                                                        <DeleteIcon className={this.props.classes.leftIcon} />

                                                    </Button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        </Grid> */}

                    </Grid>


                    : ''}

                {this.state.timetable ?
                    <div
                        className={this.props.classes.pdTop}
                        title="Timetable Details"
                    >

                        {this.state.property && (
                            <TimetableTableList
                                refresh_data={this.refresh.bind(this)}
                                property_id={this.props.property_id}
                                showroom_timetable={this.state.timetable}
                                showroom_agencies={this.state.agencies}
                                className={this.props.classes.results}
                                property={this.state.property}
                                openaddspecialday={this.openAddSpecialDay.bind(this)}
                            />
                        )}
                    </div> : ''}
                {this.state.setOpenAdd == 'addAgency' ?
                    <AddAgency
                        property_id={this.props.property_id}
                        agencies={this.state.unadded_agencies}
                        onClose={this.handleAddClose}
                        open={this.state.open}
                    />
                    :
                    this.state.setOpenAdd == 'addOperator' ?
                        <AddOperator
                            property_id={this.props.property_id}
                            operators={this.state.unadded_operators}
                            onClose={this.handleAddClose}
                            open={this.state.open}
                        ></AddOperator>

                        : ''
                }
                {
                    this.state.setOpenAdd == "addShowroomUnit" ?
                        <AddShowflat
                            property_id={this.props.property_id}
                            operators={this.state.unadded_operators}
                            onClose={this.handleAddClose}
                            open={this.state.open}
                        ></AddShowflat> : ''
                }
                {this.state.setOpenAdd == 'reorder_units' ? (
                    <ReorderUnits {...this.props} units={this.state.property.units} onClose={this.handleAddClose}></ReorderUnits>
                ) : ''}
                {
                    this.state.addSpecialDay &&
                    (<CopyDate
                        ref={(ref) => this.copy_date_form}
                        property_id={this.props.property_id}
                        special_dates={this.state.timetable.special}
                        open={this.state.addSpecialDay}
                        onClose={this.closeAddSpecialDay.bind(this)}
                    ></CopyDate>)

                }
            </div>
        )
    }
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}



